/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */

import findIndex from 'lodash/findIndex'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_API_KEYS } from '../../actions.type'
import {
  CREATE_API_KEY,
  REMOVE_API_KEY,
  SET_API_KEY_ALL_REQUEST,
  SET_API_KEY_ALL_VALUE,
  UPDATE_API_KEY
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  apiKeyAllValue: (state) => state.all.value,
  apiKeyAllRequest: (state) => state.all.request,
  apiKeyAllById: (state) => keyBy(state.all.value, 'id')
}

const actions = {
  async [FETCH_API_KEYS]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('api-key', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_API_KEY_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_API_KEY_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_API_KEY_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_API_KEY_ALL_VALUE, data)
    } catch (e) {
      commit(SET_API_KEY_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_API_KEY({ commit }, value) {
    commit(CREATE_API_KEY, value)
  },

  async SOCKET_UPDATE_API_KEY({ commit }, value) {
    commit(UPDATE_API_KEY, value)
  },

  async SOCKET_REMOVE_API_KEY({ commit }, id) {
    commit(REMOVE_API_KEY, id)
  }
}

const mutations = {
  [SET_API_KEY_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_API_KEY_ALL_VALUE](state, apiKeys) {
    state.all.value = apiKeys
  },
  [UPDATE_API_KEY](state, updatedApiKey) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedApiKey.id }),
      1,
      updatedApiKey
    )
  },
  [CREATE_API_KEY](state, createdApiKey) {
    state.all.value.push(createdApiKey)
  },
  [REMOVE_API_KEY](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
